import { render, staticRenderFns } from "./TabSlot.vue?vue&type=template&id=a403d2c0"
import script from "./TabSlot.vue?vue&type=script&lang=ts"
export * from "./TabSlot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports